import { useValidators } from "@/composables/useValidators";
import type { Composer } from "vue-i18n";

/**
 * Single source of truth for the signup contact-review field validators
 * (account contact + company details).
 *
 * Shared by the form that renders the inline errors
 * (DefaultContactReviewConfigurationComponent) and by any flow that gates submit
 * on the same rules (e.g. InternationalSignupFlow), so the submit gate and the
 * inline errors can never drift apart. The shapes are deliberately Vuelidate-rule
 * shaped (`{ field: { validator, ... } }`) so both consumers can use them directly.
 */
export function useContactReviewValidation(t: Composer["t"]) {
  const {
    required,
    isValidVAT,
    validRegistryCode,
    validAddress,
    validRepresentativeName,
    validRepresentativePhone,
  } = useValidators(t);

  const accountRules = {
    name: { required, validRepresentativeName },
    phone_number: { required, validRepresentativePhone },
  };

  const companyRules = {
    name: { required },
    registry_code: { required, validRegistryCode },
    address: { required, validAddress },
    vat: { isValidVAT }, // optional, but validated if provided
  };

  return { accountRules, companyRules };
}
